import { RootState } from "app/store";
import { pricingSliceInitialState, PricingState } from "../pricingSlice";

export const selectPricingState = (state: RootState): PricingState => {
  return state.pricing || pricingSliceInitialState;
};

